import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconBellOutlined: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7203 13.4038L20.5213 15.2078C20.9903 15.6768 21.1283 16.3768 20.8733 16.9908C20.6193 17.6038 20.0273 17.9998 19.3633 17.9998H16.0003V18.3408C16.0003 20.3588 14.2063 21.9998 12.0003 21.9998C9.79434 21.9998 8.00034 20.3588 8.00034 18.3408V17.9998H4.63734C3.97334 17.9998 3.38034 17.6038 3.12534 16.9898C2.87134 16.3768 3.01034 15.6778 3.47934 15.2078L5.28034 13.4038L5.28134 8.72683C5.28134 6.79283 6.11934 4.94883 7.58334 3.66683C9.03834 2.39083 10.9783 1.80383 12.9003 2.05983C16.2183 2.49883 18.7203 5.45583 18.7203 8.93683V13.4038ZM5.51534 15.9998L6.69534 14.8178C7.07334 14.4398 7.28134 13.9378 7.28134 13.4038V8.72683C7.28134 7.36983 7.87134 6.07283 8.90134 5.17083C9.93934 4.26083 11.2613 3.86083 12.6383 4.04183C14.9653 4.35083 16.7203 6.45483 16.7203 8.93683V13.4038C16.7203 13.9378 16.9283 14.4398 17.3053 14.8168L18.4863 15.9998H5.51534ZM14.0003 18.3408C14.0003 19.2398 13.0843 19.9998 12.0003 19.9998C10.9163 19.9998 10.0003 19.2398 10.0003 18.3408V17.9998H14.0003V18.3408Z"
        fill={fill}
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="3"
        y="2"
        width="18"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.7203 13.4038L20.5213 15.2078C20.9903 15.6768 21.1283 16.3768 20.8733 16.9908C20.6193 17.6038 20.0273 17.9998 19.3633 17.9998H16.0003V18.3408C16.0003 20.3588 14.2063 21.9998 12.0003 21.9998C9.79434 21.9998 8.00034 20.3588 8.00034 18.3408V17.9998H4.63734C3.97334 17.9998 3.38034 17.6038 3.12534 16.9898C2.87134 16.3768 3.01034 15.6778 3.47934 15.2078L5.28034 13.4038L5.28134 8.72683C5.28134 6.79283 6.11934 4.94883 7.58334 3.66683C9.03834 2.39083 10.9783 1.80383 12.9003 2.05983C16.2183 2.49883 18.7203 5.45583 18.7203 8.93683V13.4038ZM5.51534 15.9998L6.69534 14.8178C7.07334 14.4398 7.28134 13.9378 7.28134 13.4038V8.72683C7.28134 7.36983 7.87134 6.07283 8.90134 5.17083C9.93934 4.26083 11.2613 3.86083 12.6383 4.04183C14.9653 4.35083 16.7203 6.45483 16.7203 8.93683V13.4038C16.7203 13.9378 16.9283 14.4398 17.3053 14.8168L18.4863 15.9998H5.51534ZM14.0003 18.3408C14.0003 19.2398 13.0843 19.9998 12.0003 19.9998C10.9163 19.9998 10.0003 19.2398 10.0003 18.3408V17.9998H14.0003V18.3408Z"
          fill={fill}
        />
      </mask>
    </Icon>
  );
};

export default IconBellOutlined;
